export function resolveTurnstileConfig(serverRoot, app) {
  return {
    mode: serverRoot?.dataset?.turnstileMode || app?.dataset?.turnstileMode || "unavailable",
    sitekey: serverRoot?.dataset?.turnstileSitekey || app?.dataset?.turnstileSitekey || ""
  };
}
